export function fromObject(value) {
    return value ? Buffer.from(JSON.stringify(value)).toString('base64') : '';
}
export function toObject(value) {
    if (value === void 0) { value = ''; }
    return value ? JSON.parse(Buffer.from(value, 'base64').toString()) : null;
}
export function toHex(value) {
    if (value === void 0) { value = ''; }
    var BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz';
    var b64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var ret = '';
    var state = 0;
    var slop = 0;
    for (var i = 0; i < value.length; ++i) {
        if (value.charAt(i) === '=') {
            break;
        }
        var v = b64map.indexOf(value.charAt(i));
        if (v >= 0) {
            switch (state) {
                case 0:
                    ret += BI_RM.charAt(v >> 2);
                    slop = v & 3;
                    state = 1;
                    break;
                case 1:
                    ret += BI_RM.charAt((slop << 2) | (v >> 4));
                    slop = v & 0xf;
                    state = 2;
                    break;
                case 2:
                    ret += "".concat(BI_RM.charAt(slop)).concat(BI_RM.charAt(v >> 2));
                    slop = v & 3;
                    state = 3;
                    break;
                default:
                    ret += "".concat(BI_RM.charAt((slop << 2) | (v >> 4))).concat(BI_RM.charAt(v & 0xf));
                    state = 0;
                    break;
            }
        }
    }
    if (state === 1) {
        ret += BI_RM.charAt(slop << 2);
    }
    return ret;
}
export function fromFile(file) {
    return new Promise(function (resolve, reject) {
        var fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = function () { return resolve(String(fileReader.result)); };
        fileReader.onerror = function (error) { return reject(error); };
    });
}
//# sourceMappingURL=base64.js.map